/**
 * @generated SignedSource<<72806d04cace0c8b1a96fe528207e9ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DistributionStatus = "ACTIVE" | "INACTIVE" | "%future added value";
export type ActivateDistributionStatusableInput = {
  clientMutationId?: string | null;
  distributionStatusableId: string;
};
export type DistributionStatusSwitch_ActivateMutation$variables = {
  input: ActivateDistributionStatusableInput;
};
export type DistributionStatusSwitch_ActivateMutationVariables = DistributionStatusSwitch_ActivateMutation$variables;
export type DistributionStatusSwitch_ActivateMutation$data = {
  readonly updateStatus: {
    readonly distributionStatusable: {
      readonly status: DistributionStatus;
    };
    readonly disabledLinkedUserTagModules: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly effectiveEnabled: boolean;
    }>;
  } | null;
};
export type DistributionStatusSwitch_ActivateMutationResponse = DistributionStatusSwitch_ActivateMutation$data;
export type DistributionStatusSwitch_ActivateMutation = {
  variables: DistributionStatusSwitch_ActivateMutationVariables;
  response: DistributionStatusSwitch_ActivateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "UserTagModule",
  "kind": "LinkedField",
  "name": "disabledLinkedUserTagModules",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "effectiveEnabled",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DistributionStatusSwitch_ActivateMutation",
    "selections": [
      {
        "alias": "updateStatus",
        "args": (v1/*: any*/),
        "concreteType": "ActivateDistributionStatusablePayload",
        "kind": "LinkedField",
        "name": "activateDistributionStatusable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "distributionStatusable",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DistributionStatusSwitch_ActivateMutation",
    "selections": [
      {
        "alias": "updateStatus",
        "args": (v1/*: any*/),
        "concreteType": "ActivateDistributionStatusablePayload",
        "kind": "LinkedField",
        "name": "activateDistributionStatusable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "distributionStatusable",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5593dd29914c7aca7aa4de77c56a62cb",
    "id": null,
    "metadata": {},
    "name": "DistributionStatusSwitch_ActivateMutation",
    "operationKind": "mutation",
    "text": "mutation DistributionStatusSwitch_ActivateMutation(\n  $input: ActivateDistributionStatusableInput!\n) {\n  updateStatus: activateDistributionStatusable(input: $input) {\n    distributionStatusable {\n      __typename\n      status\n      id\n    }\n    disabledLinkedUserTagModules {\n      id\n      name\n      effectiveEnabled\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f26b7f8510deb42ca4b44f68da0bbbef";

export default node;
